<template>
  <div id="horaires_perso">
    <router-link to="/horaires">
      <img class="imgicon" src="img/back.png" />
    </router-link>
    <h2>Planning par employé</h2>
    <div class="form-group">
      <label for="employe">Employé :</label>
      <select @change="loadData" v-model="employe" id="employe" class="custom-select">
        <option :value="undefined">Sélectionner un employé</option>
        <option value="-1">QSP</option>
        <option
          v-for="employe of employes"
          :key="employe.id"
          :value="employe.id"
        >{{employe.acronyme}} - {{employe.nom}} {{employe.prenom}}</option>
      </select>
    </div>
    <div v-if="employe">
    <a
      :class="filteredHoraires.length <= 0?`disabled-link`:``"
      href="javascript:"
      class="mr-3"
      @click="generatePDF()"
    >
      <img class="imgicon" src="img/pdf.png" /> Télécharger en PDF
    </a>
    <a :class="filteredHoraires.length <= 0?`disabled-link`:``" href="javascript:" @click="generateIcal()">
      <img class="imgicon" src="img/calendar.png" /> Exporter pour un agenda
    </a>
    <div class="mt-3 form-inline filtre">
      <label for="begindate">Date de début</label>
      <date-picker
        @change="onDateChange"
        type="date"
        format="dd DD/MM/YYYY"
        v-model="filters.begindate"
      />
      <label class="ml-3" for="enddate">Date de fin</label>
      <date-picker
        @change="onDateChange"
        type="date"
        format="dd DD/MM/YYYY"
        v-model="filters.enddate"
      />
      <label class="ml-3" for="fonction">Fonction</label>
      <select
        class="form-control custom-select"
        id="fonction"
        name="fonction"
        v-model="filters.fonction"
      >
        <option selected :value="undefined">-</option>
        <option
          v-for="fonction in fonctions"
          v-bind:key="fonction.id"
          v-bind:value="fonction.id"
        >{{fonction.nom}}</option>
      </select>
      <label for="site">Site</label>
      <select id="site" name="site" class="form-control custom-select" v-model="filters.site">
        <option selected :value="undefined">-</option>
        <option v-for="site in sites" v-bind:key="site.id" v-bind:value="site.id">{{site.nom}}</option>
      </select>
    </div>
    <p v-if="datealert">
      <img class="imgicon" src="img/warning_yellow.png" />&nbsp;La date de début doit être inférieure à la date de fin
    </p>
    <b-pagination
      v-if="filteredHoraires.length > 0"
      class="mt-3"
      v-model="currentPage"
      :total-rows="filteredHoraires.length"
      :per-page="perPage"
      aria-controls="table-horaires"
      align="fill"
      :limit="15"
      size="sm"
    >
      <template v-slot:page="{ page, active }">
        <span style="color:white;" v-if="active">{{ page }}</span>
        <span v-else>{{ page }}</span>
      </template>
    </b-pagination>
    <b-table
      responsive="sm"
      :items="filteredHoraires"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      class="mt-3"
      id="table-horaires"
      v-if="filteredHoraires.length > 0"
      small
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      sort-icon-left
      :tbody-tr-class="rowClass"
    >
      <template v-slot:table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.key"
          :width="(field.key === 'id' || field.key === 'fonction') ? '10%' : '16%'"
        />
      </template>
      <template v-slot:cell(id)="data"><router-link :to="`/horaires/modification/${data.item.id}`">{{data.item.id}}</router-link></template> 
      <template v-slot:cell(date)="data">{{utils.toPrettyDate(data.item.date)}}</template>
      <template v-slot:cell(site)="data">{{sitesById[data.item.id_site].nom}}</template>
      <template v-slot:cell(fonction)="data">{{fonctionsById[data.item.id_fonction].nom}}</template>
      <template v-slot:cell(sceances)="data">
        <seances :item="data.item" />
      </template>
      <template v-slot:cell(rem)="data">{{data.item.remarque}}</template>
    </b-table>
    <h5 class="pt-5" v-else>Pas d'horaire à signaler...</h5>
  </div>
  </div>
</template>

<script>
import api from "@/api";
import utils from "@/utils";
import Swal from "sweetalert2";
import Seances from "@/components/Seances";
import moment from "moment";
import DatePicker from "vue2-datepicker";

export default {
  data() {
    return {
      horaires: [],
      perPage: 15,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      employe: undefined,
      fields: [
        { key: "id", label: "Référence", sortable: true },
        { key: "date", label: "Date", sortable: true },
        { key: "site", label: "Site", sortable: false },
        { key: "fonction", label: "Fonction", sortable: false },
        { key: "sceances", label: "Séances", sortable: false },
        { key: "rem", label: "Remarque", sortable: false }
      ],
      utils: utils,
      filters: {
        fonction: undefined,
        site: undefined,
        begindate: "",
        enddate: "",
      },
      datealert: false,
      sites: [],
      sitesById: [],
      fonctions: [],
      fonctionsById: [],
      employes: [],
      employesById: [],
    };
  },
  components: { Seances, DatePicker },
  async created() {
    this.$store.commit("setLoading", true);
    this.fonctions = (await api.getFonctions()).data.fonctions;
    for (let fonction of this.fonctions) {
      this.fonctionsById[fonction.id] = fonction;
    }
    this.sites = (await api.getSites()).data.sites;
    for (let site of this.sites) {
      this.sitesById[site.id] = site;
    }
    this.employes = (await api.getEmployes()).data.employes;
    for (let employe of this.employes) {
      this.employesById[employe.id] = employe;
    }
    this.$store.commit("setLoading", false);
  },
  computed: {
    filteredHoraires() {
      return this.horaires.filter((horaire) => {
        let ok = true;
        if (this.filters.fonction !== undefined) {
          if (horaire.id_fonction !== this.filters.fonction) {
            ok = false;
          }
        }
        if (ok && this.filters.site !== undefined) {
          if (horaire.id_site !== this.filters.site) {
            ok = false;
          }
        }
        if (ok && this.filters.begindate !== null) {
          if (moment(horaire.date).isBefore(this.filters.begindate, "day")) {
            ok = false;
          }
        }
        if (ok && this.filters.enddate !== null) {
          if (moment(horaire.date).isAfter(this.filters.enddate, "day")) {
            ok = false;
          }
        }
        if (ok && !horaire.visible && horaire.type < 2) {
          ok = false;
        }
        return ok;
      });
    },
  },
  methods: {
    async loadData() {
      let employe = this.employe;
      if (employe < 0){ //QSP
        this.horaires = (await api.getQSPsProposition()).data.qsp;
        this.horaires = this.horaires.concat((await api.getQSPsValidation()).data.qsp);
      }else{
        this.horaires = (await api.getHorairesParEmploye(employe)).data.horaires;
      }
    },
    onDateChange() {
        this.datealert =
        this.filters.begindate !== null &&
        this.filters.enddate !== null &&
        moment(this.filters.begindate).isAfter(this.filters.enddate, "day");
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.sib) return "table-secondary";
    },
    generatePDF() {
      let id = this.employe;
      const filter = {
        begindate: moment(this.filters.begindate).utc(true).toDate(),
        enddate: moment(this.filters.enddate).utc(true).toDate(),
        fonction: this.filters.fonction,
        site: this.filters.site
      }
      api.pdf(`horairesemploye`, { id, filters: filter }, `horaire`);
    },
    generateIcal() {
      let id = this.employe;
      api.ical(`horairesemploye`, { id, filters: this.filters }, `horaire`);
    },
  },
};
</script>